import { motion } from "framer-motion";
import { Eye, Target } from "lucide-react";

export default function Nosotros() {
  return (
    <section
      id="nosotros"
      className="py-20 md:py-32 bg-[#0D1525]"
      data-testid="nosotros-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section label */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <span className="text-[#3DD9E8] text-sm font-bold uppercase tracking-[0.3em] font-body">
            Sobre nosotros
          </span>
          <h2 className="font-heading text-4xl md:text-6xl text-white uppercase tracking-tight mt-3 mb-12">
            Puerto Deseado Turismo SRL
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Image */}
          <motion.div
            className="relative overflow-hidden"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img
              src="/assets/590-2.jpeg"
              alt="Flota Puerto Deseado"
              className="w-full aspect-[4/3] object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#D0162A]" />
          </motion.div>

          {/* Text content */}
          <motion.div
            className="space-y-10"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {/* Mission */}
            <div className="relative pl-8 border-l-2 border-[#D0162A]">
              <div className="flex items-center gap-3 mb-4">
                <Target className="text-[#3DD9E8]" size={22} />
                <h3 className="font-heading text-2xl md:text-3xl text-white uppercase tracking-wide">
                  Mision
                </h3>
              </div>
              <p className="text-gray-300 font-body font-light leading-relaxed text-base md:text-lg">
                En Puerto Deseado Turismo Srl., nuestra mision es ofrecer experiencias de transporte
                excepcionales para turistas, garantizando comodidad, seguridad y un servicio
                personalizado. Nos comprometemos a conectar a nuestros pasajeros con los destinos
                mas hermosos, brindando un servicio de calidad que supere sus expectativas.
              </p>
            </div>

            {/* Vision */}
            <div className="relative pl-8 border-l-2 border-[#1B3A8C]">
              <div className="flex items-center gap-3 mb-4">
                <Eye className="text-[#3DD9E8]" size={22} />
                <h3 className="font-heading text-2xl md:text-3xl text-white uppercase tracking-wide">
                  Vision
                </h3>
              </div>
              <p className="text-gray-300 font-body font-light leading-relaxed text-base md:text-lg">
                Nuestra vision es ser la empresa lider en traslados turisticos en la region, reconocida
                por nuestra excelencia en el servicio y nuestra dedicacion al cliente. Aspiramos a
                expandir nuestras operaciones y ser la primera opcion para los viajeros que buscan
                un transporte confiable y placentero.
              </p>
            </div>

            {/* Services summary */}
            <div className="relative pl-8 border-l-2 border-[#3DD9E8]">
              <h3 className="font-heading text-2xl md:text-3xl text-white uppercase tracking-wide mb-4">
                Servicios
              </h3>
              <p className="text-gray-300 font-body font-light leading-relaxed text-base md:text-lg">
                Ofrecemos traslados de pasajeros de turismo, tanto individuales como grupales,
                utilizando una flota moderna y variada que incluye van, combis y buses con
                capacidad para hasta 60 pasajeros. Nos adaptamos a las necesidades de nuestros
                clientes, asegurando un viaje comodo y seguro.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
